<template>
  <el-dialog :border="false" ref="wDialog" closeFree :top="popTop" width="836px" @ok="selectOk" :title="title":visible.sync="visible" append-to-body	>
    <div class="picker">
      <div class="candidate" >
        <div class="selected-title">
          <div class="title-name">请选择</div>
        </div>
        <el-tabs v-model="activeName" @tab-click="toggleTab" type="card" size="small"  class="custom-tabs" v-if="tabsType!='user' && tabsType!='role' && tabsType!='dept'">
          <el-tab-pane label="部门" name="dept"></el-tab-pane>
          <el-tab-pane label="员工" name="user"></el-tab-pane>
          <el-tab-pane label="角色" name="role"></el-tab-pane>
        </el-tabs>
        <!-- {{ checkDept }}{{ checkUser }}{{ checkRole }}{{ defaultUserIds }} -->
        <!-- 部门 -->
        <div  v-show="activeName === 'dept'" class="org-items org-items-dept" :style="leftDeptHeight" v-loading="loading">
          <el-tree
            v-show="nodes.length != 0"
            ref="treeDept"
            :data="nodes"
            show-checkbox
            :check-strictly="true"
            node-key="id"
            :default-checked-keys="checkDept"
            :props="defaultProps"
            @check-change ="selectChange">
          </el-tree>
        </div>
        <!-- 员工 -->
        <div  v-show="activeName === 'user'" >
          <div class="search-user-con" >
            <el-cascader ref="cascaderDept" @change="searchUserOrg" v-model="searchForm.orgId" :options="deptList" :show-all-levels="false" size="medium" class="input-1" placeholder="选择部门" :props="{
                        checkStrictly: true,
                        label: 'orgName',
                        value: 'orgPath',
                        children: 'children',
                    }" clearable filterable></el-cascader>
            <el-input placeholder="搜索员工" prefix-icon="el-icon-search" v-model="searchForm.keyword" @input="debouncedGetOrgList" size="medium" class="input-2" clearable></el-input>
          </div>
          <div class="org-items org-items-user" :style="leftHeight"  v-loading="loading">
            <!-- 多选 -->
            <el-checkbox-group v-model="checkUser" v-if="multiple">
              <el-checkbox :label="item.sysUserId" v-for="(item, index) in nodes" :key="index" class="item-user" @change="selectChange(item,$event,)" :disabled="defaultUserIds.includes(item.sysUserId)">
                <div class="name-con"><span class="no">{{ item.serial }}</span><span class="name">{{ item.reallyName }}</span><span class="phone">({{ item.phoneNumber }})</span></div>
                <div class="org-con"><span class="org">({{ item.orgName }})</span></div>
              </el-checkbox>
            </el-checkbox-group>
            <!-- 单选 -->
            <el-radio-group v-model="checkUser[0]" v-else>
              <el-radio :label="item.sysUserId" v-for="(item, index) in nodes" :key="index" class="item-user" @change="selectChange(item,$event,)">
                <div class="name-con"><span class="no">{{ item.serial }}</span><span class="name">{{ item.reallyName }}</span><span class="phone">({{ item.phoneNumber }})</span></div>
                <div class="org-con"><span class="org">({{ item.orgName }})</span></div>
              </el-radio>
            </el-radio-group>
            <el-empty v-if="totalNum==0" :image-size="100" description="找不到相关员工"/>
          </div>
        </div>
        <!-- 角色 -->
        <div  v-show="activeName === 'role'" >
          <div class="search-user-con">
            <el-input placeholder="搜索角色" prefix-icon="el-icon-search" v-model="searchForm.roleName" @input="debouncedGetOrgList" size="medium" class="input-3" clearable></el-input>
          </div>
          <div class="org-items org-items-user" :style="leftHeight"  v-loading="loading">
            <el-checkbox-group v-model="checkRole" >
              <el-checkbox :label="item.id" v-for="(item, index) in nodes" :key="index" class="item-user" @change="selectChange(item,$event,)">
                <div class="name-con">{{ item.name }}</div>
              </el-checkbox>
            </el-checkbox-group>
            <el-empty v-if="totalNum==0" :image-size="100" description="找不到相关角色"/>
          </div>
        </div>
       
      </div>
      <div class="selected">
        <div class="selected-title">
          <div class="title-name">已选择</div>
          <div class="count">{{ select.length }}</div>
          <!-- <span @click="clearSelected">清空</span> -->
        </div>
        <div class="org-items">
          <!-- {{ select }} -->
          <el-empty :image-size="100" description="请点击左侧列表选择数据" v-if="select.length === 0"/>
          <div v-else class="selected-list">
            <div class="item" :class="{ 'item-disabled': org.disabled, 'item-single': !multiple}" v-for="(org, index) in select" :key="index" >
              <span class="name">{{ org.serial }}{{ org.name }}</span>
              <i class="el-icon-close" @click="noSelected(org)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div slot="footer">
      <el-button size="small" @click="visible = false;">取 消</el-button>
      <el-button size="small" type="primary" @click="selectOk">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import {getOrgTree, getUserByName} from '@/api/org'
import _ from 'lodash'; // 引入 lodash
export default {
  name: "OrgPicker",
  components: {},
  props: {
    title: {
      default: '请选择',
      type: String
    },
    type: {
      default: 'org', //org选择部门/人员  user-选人  dept-选部门 role-选角色
      type: String
    },
    multiple: { //是否多选
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      visible: false,
      popTop:'',
      clientHeight:'',
      loading: false,
      checkAll: false,
      isIndeterminate: false,
      searchUsers: [],
      nodes: [],
      totalNum:-1,
      selected:[],
      select: [],
      search: '',
      deptStack: [],
      activeName:'',
      defaultProps: {
        children: 'children',
        label: 'orgName'
      },
      checkDept:[],
      checkUser:[],
      checkRole:[],
      defaultUserIds:[],
      searchForm:{},
      deptList:[],
      tabsType:'',
      comment:'',
      remarks:'',
      approveComment:'', // 审批通过备注
      signType:'',
      options: [{
          value: 'BEFORE',
          label: '前加签'
        }, {
          value: 'AFTER',
          label: '后加签'
        }]
    }
  },
  computed: {
    deptStackStr() {
      return String(this.deptStack.map(v => v.name)).replaceAll(',', ' > ')
    },
    orgs() {
      return !this.search || this.search.trim() === '' ? this.nodes : this.searchUsers
    },
    showUsers(){
      return this.search || this.search.trim() !== ''
    },
    // 部门高度
    leftDeptHeight(){
      if (this.tabsType==='dept') {
        return {
          height:'543px'
        }
      }else{
        return {
          height:'489px'
        }
      }
    },
    // 左侧高度 单个时缺少tabs 所以要加高
    leftHeight(){
      if (this.tabsType==='user' || this.tabsType==='role') {
        return {
          height:'498px'
        }
      }else{
        return {
          height:'442px'
        }
      }
    }
  },
  created() {
    // 初始化防抖函数
    this.debouncedGetOrgList = _.debounce(this.getOrgList, 500); 
  },
  mounted() {
    // this.getOrgList()
  },
  methods: {
    show(selected=[],tabsType) {
      console.log('show>>',selected,tabsType)
      this.defaultUserIds= selected.filter(e=>e.disabled).map(e=>+(e.id||e.userId))
      this.clientHeight = document.documentElement.clientHeight
      this.visible = true
      this.selected = selected || []
      this.tabsType = tabsType
      if(tabsType === 'user'){
        this.activeName = 'user'
        this.fetchDeptList()
      }else if (tabsType === 'role') {
        this.activeName = 'role'
      }else if (tabsType === 'dept') {
        this.activeName = 'dept'
      }else{
        this.activeName = 'dept'
      }
      this.popHeight = '716'
      this.searchForm.orgId =''
      this.searchForm.keyword =''
      this.searchForm.roleName =''
      this.getOrgList()
      this.init()
      this.initPopTop()
    },
    // 计算浮层距离顶部的高度
    initPopTop(){
      this.popTop=this.clientHeight > this.popHeight ? Math.floor((this.clientHeight - this.popHeight) / 2) + 'px' : '10px'
    },
    toggleTab() {
      this.nodes = []
      this.getOrgList()
      if(this.activeName==='dept'){
        console.log('dept set>>',this.checkDept)
        this.$nextTick(()=>{
          this.checkDept.forEach(id=>{
            this.$refs.treeDept.setChecked(id,true)
          })
        })
      }
    },
    orgItemClass(org){
      return {
        'org-item': true,
        'org-dept-item': org.type === 'dept',
        'org-user-item': org.type === 'user',
        'org-role-item': org.type === 'role'
      }
    },
    disableDept(node) {
      return this.type === 'user' && 'dept' === node.type
    },
    getOrgList() {
      console.log('getOrgList>>')
      this.loading = true
      this.nodes = []
      this.totalNum = -1
      let postData = {}
      let apiUrl
      if(this.activeName ==='dept'){
        apiUrl = 'orgTree'
        postData = {
            orgName: "",
            status: "",
        }
      }else if(this.activeName ==='user'){
        apiUrl = 'employeeList'
        postData = {
          pageSize:50,    
        }
        let orgId
        if(this.searchForm.orgId){
          orgId = this.searchForm.orgId[this.searchForm.orgId.length - 1]
          postData.orgId = orgId
        }
        if(this.searchForm.keyword){
          postData.reallyName = this.searchForm.keyword
        }
      }else if(this.activeName ==='role'){
        apiUrl = 'rolePageList'
        postData = {
          pageSize:50,       
        }
        postData.name = this.searchForm.roleName
      }
      this.$api[apiUrl](postData).then(res => {
        this.loading = false
        let data = res.data
        if(this.activeName ==='dept'){
          this.nodes = data
          this.deptList = data
        }else if(this.activeName ==='user'){
          this.nodes = data.list
          this.totalNum = data.totalNum
        }else if(this.activeName ==='role'){
          this.nodes = data.list
          this.totalNum = data.totalNum
        }
        
        // this.selectToLeft()
      }).catch(err => {
        this.loading = false
        this.$message.error(err.response.data)
      })
    },
    // 获取部门列表 user 初始化用
    fetchDeptList(){
      console.log('fetchDeptList>>',)
      const postData = {
            orgName: "",
            status: "",
        }
      this.$api.orgTree(postData).then(res => {
        this.loading = false
        this.deptList = res.data
      }).catch(err => {
        this.loading = false
        this.$message.error(err.response.data)
      })
    },
    // checkDept(data, checked, indeterminate){
    //   console.log(data, checked, indeterminate);
    //   this.select = data
    // },
    handleNodeClick(data) {
        console.log('>>',data,this.select)
    },
    loadNode(){},
    getShortName(name) {
      if (name) {
        return name.length > 2 ? name.substring(1, 3) : name;
      }
      return '**'
    },

    selectChange(item,selected) {
      const node = {
        id:item.sysUserId || item.id,
        serial:item.serial,
        name:item.reallyName || item.orgName || item.name,
        selected:!selected,
        type:this.activeName
      }
      // console.log('>>',node,selected)
      if (node.selected) {
        this.checkAll = false;
        for (let i = 0; i < this.select.length; i++) {
          if (this.select[i].id === node.id) {
            this.select.splice(i, 1);
            break;
          }
        }
        item.selected = false;
        node.selected = false;
      } else if (!this.disableDept(node)) {
        item.selected = true
        node.selected = true
        let nodes = this.search.trim() === '' ? this.nodes : this.searchUsers;
        if (!this.multiple) {
          nodes.forEach(nd => {
            if (node.id !== nd.id) {
              nd.selected = false
            }
          })
        }
        if (node.type === 'dept') {
          if (!this.multiple) {
            // 单选-取消所有选中
            this.$refs.treeDept.setCheckedKeys([]);
            this.select = [node]
          } else {
            this.select.push(node);
          }
          let deptNode = this.select.filter(e => e.type === 'dept')
          this.checkDept = deptNode.map(e=>e.id)
        } else {
          if (!this.multiple) {
            this.select = [node]
          } else {
            this.select.push(node);
          }
        }
      }
    },
    noSelected(item){
      console.log('noSelected：',item)
      
      if(item.type == 'dept'){
        // if(this.multiple){
          this.$refs.treeDept.setChecked(item.id,false)
          this.checkDept = this.checkDept.filter(id=>id != item.id);
          this.select = this.select.filter(e=>e.id != item.id);
        // }else{
          // this.checkDept = []
          // this.select = []
        // }
      }else if(item.type == 'user'){
        if(this.multiple){
          this.checkUser = this.checkUser.filter(id=>id != item.id);
          this.select = this.select.filter(e=>e.id != item.id);
        }else{
          this.checkUser = []
          this.select = []
        }
      }else if(item.type == 'role'){
        if(this.multiple){
          this.checkRole = this.checkRole.filter(id=>id != item.id);
          this.select = this.select.filter(e=>e.id != item.id);
        }else{
          this.checkRole = []
          this.select = []
        }
      }else{
        this.select = this.select.filter(e=>e.id != item.id);
      }
    },
    // 员工选择
    searchUserOrg(e){
      this.searchForm.orgId = e
      this.getOrgList()
      console.log('>>',this.$refs.cascaderDept)
      this.$refs.cascaderDept._data.dropDownVisible = false;
      // this.$refs.cascaderDept.togglePopperVisible(false);
    },
    handleCheckAllChange() {
      this.nodes.forEach(node => {
        if (this.checkAll) {
          if (!node.selected && !this.disableDept(node)) {
            node.selected = true
            this.select.push(node)
          }
        } else {
          node.selected = false;
          for (let i = 0; i < this.select.length; i++) {
            if (this.select[i].id === node.id) {
              this.select.splice(i, 1);
              break;
            }
          }
        }
      })
    },
    recover() {
      this.select = []
      this.nodes.forEach(nd => nd.selected = false)
    },
    selectOk() {
      this.$emit('ok', Object.assign([], this.select))
      this.visible = false
    },
    clearSelected(){
      this.$confirm('您确定要清空已选中的项?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.recover()
      })
    },
    close() {
      this.$emit('close')
      this.recover()
    },
    init() {
      this.searchForm = {}
      this.select = Object.assign([], this.selected)
      this.checkDept = []
      this.checkUser = []
      this.checkRole = []
      this.select.forEach(e=>{
        if(e.type == 'dept'){
          this.checkDept.push(e.id)
        }else if(e.type == 'user'){
          let id = +(e.id || e.userId)
          this.checkUser.push(id)
        }else if(e.type == 'role'){
          this.checkRole.push(e.id)
        }
      })
      console.log('init>>',this.checkUser, this.select)
    }
  }
}
</script>

<style lang="scss" scoped>

$theme-primary:red;

.candidate, .selected {
  position: absolute;
  display: inline-block;
  // height: 400px;
  // border: 1px solid #e8e8e8;
}
.candidate{
  width: 385px;
}
.selected{
  width: 370px;
}

.picker {
  height: 595px;
  position: relative;
  text-align: left;
  .selected-title{
    display:flex;
    margin-bottom: 16px;
    padding-top: 10px;
    .title-name{
      font-weight: bold;
      font-size: 16px;
      color: #2F3030;
      position: relative;
      padding-left: 6px;
      margin-right: 20px;
      &:after{
        content: '';
        position: absolute;
        left: 0;
        top:5px;
        width: 2px;
        height: 16px;
        background: #2D7DDF;
        
      }
    }
    .count{
      height: 24px;
      padding: 0 8px;
      background: #2D7DDF;
      border-radius: 12px;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      justify-content: center;
      align-items: center;
      font-family: "PingFang SC", "Microsoft YaHei",Arial,sans-serif;
    }
  }
  .candidate {
    left: 0;
    top: 0;
    .custom-tabs2{
      height: 50px;
      overflow: hidden;
    }
    /deep/.el-tree-node__content{
      height: 38px;
    }
    .role-header{
      padding: 10px !important;
      margin-bottom: 5px;
      border-bottom: 1px solid #e8e8e8;
    }

    .top-dept{
      margin-left: 20px;
      cursor: pointer;
      color:#38adff;
    }
    .next-dept {
      float: right;
      color: $theme-primary;
      cursor: pointer;
    }

    .next-dept-disable {
      float: right;
      color: #8c8c8c;
      cursor: not-allowed;
    }


  }

  .selected {
    right: 0;
    top: 0;
  }

  .org-items {
    overflow-y: auto;
    height: 545px;

    // .el-icon-close {
    //   position: absolute;
    //   right: 5px;
    //   cursor: pointer;
    //   font-size: larger;
    // }
    .org-dept-item {
      padding: 10px 5px;

      & > div {
        display: inline-block;

        & > span:last-child {
          position: absolute;
          right: 5px;
        }
      }
    }

    .org-role-item {
      display: flex;
      align-items: center;
      padding: 10px 5px;
    }

    /deep/ .org-user-item {
      display: flex;
      align-items: center;
      padding: 5px;

      & > div {
        display: inline-block;
      }

      .avatar {
        width: 35px;
        text-align: center;
        line-height: 35px;
        background: $theme-primary;
        color: white;
        border-radius: 50%;
      }
    }

    /deep/ .org-item {
      margin: 0 5px;
      border-radius: 5px;
      position: relative;

      .el-checkbox {
        margin-right: 10px;
      }

      .name {
        margin-left: 5px;
      }

      &:hover {
        background: #f1f1f1;
      }
    }
  }
  .search-user-con{
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    .input-1{
      width: 180px;
      margin-right: 10px;
      line-height: 35px;
    }
    .input-2{
      width: 150px;
    }
    .input-3{
      width: 340px;
    }
  }
  .org-items-user{
   .item-user{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      margin-right: 0;
      .name{
        font-weight: bold;
        font-size: 14px;
        color: #2F3030;
      }
      .no{
        font-weight: normal;
        font-size: 14px;
        color: #2F3030;
        display: inline-block;
        margin-right: 4px;
      }
      .org{
        color: #8c8c8c;
        font-weight: normal;
        display: inline-block;
        margin-right: 10px;
      }
      .phone{
        font-weight: normal;
        font-size: 12px;
        color: #8c8c8c;
        display: inline-block;
        padding-left: 5px;
      }
    }
  }
}

.selected {
    &::after{
      content: '';
      position: absolute;
      left: -17px;
      top: 10px;
      bottom: 0;
      width: 1px;
      background-color: #DFDFDF;
    }
 
}
.selected-list{
  display: flex;
  flex-wrap: wrap;
  margin-left: -20px;
  .item{
    height: 32px;
    padding: 0 0 0 16px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #E3E6E5;
    display: flex;
    align-items: center;
    margin:0 0 16px 20px;
    
    .el-icon-close{
      padding: 10px;
      cursor: pointer;
      &:hover{
        color: #38adff;
      }
    }
  }
  .item-disabled{
    padding-right: 16px;
    background-color: #F2F6FC;
    .el-icon-close{
      display: none;
    }
  }
  .item-single{
    padding-right: 16px;
    .el-icon-close{
      display: none;
    }
  }
}

/deep/ .el-dialog__body {
  padding: 0 32px;
}

.disabled{
  cursor: not-allowed !important;
  color: #8c8c8c !important;
}

::-webkit-scrollbar {
  float: right;
  width: 4px;
  height: 4px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #efefef;
}
.change-form{
  padding-top: 24px;
  /deep/{
    .el-form-item{
      margin-bottom: 12px;
    }
    .el-textarea__inner{
      padding-left: 8px;
    }
  }
}
.lable-title{
  line-height: 1.4;
  padding-top: 4px;
}
.hot{
  color: $theme-primary;
  margin-top: -5px;
}
</style>
